import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=efd1728c&scoped=true"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"
import style0 from "./Statement.vue?vue&type=style&index=0&id=efd1728c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd1728c",
  null
  
)

export default component.exports